import React from 'react'
import ReactDOM from 'react-dom'
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'

import './style.css'
import Home from './views/home'
import About from './views/about'
import WorkSamples from './views/work-samples'
import NotFound from './views/not-found'

const App = () => {
  return (
    <Router>
      <Switch>
        <Route component={Home} exact path="/" />
        <Route component={About} exact path="/about" />
        <Route component={WorkSamples} exact path="/work-samples" />
        <Route component={WorkSamples} exact path="/code-samples" />
        <Route component={NotFound} path="**" />
        <Redirect to="**" />
      </Switch>
    </Router>
  )
}

ReactDOM.render(
  <>
    <App />
    <Analytics />
  </>,
  document.getElementById('app')
)
